export const environment = {
  production: true,

  region: 'us-east-1',
  identityPoolId: 'us-east-1:c22279ad-f7e3-4fa9-93d4-098afd6f34fd',
  userPoolId: 'us-east-1_W3suNlI8o',
  clientId: '2qkbbhteitdh8e8s6vh90btk12'
};



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/environments/environment.prod.ts